import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const ContactCard = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      component={Card}
      boxShadow={0}
      border={{
        xs: 0,
        md: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box
        paddingX={{ xs: 0, md: 3 }}
        paddingTop={3}
        paddingBottom={{ xs: 0, md: 3 }}
      >
        <Typography
          sx={{
            fontWeight: '700',
          }}
          gutterBottom
        >
          {t("privacy_page.how_contact_us")}
        </Typography>
        <Typography
          variant={'body2'}
          color={'textSecondary'}
          sx={{
            marginBottom: 2,
          }}
        >
          {t("privacy_page.if_questions")}, {t("privacy_page.contacts_us")}
        </Typography>
        <Typography variant={'subtitle2'} mb={2}>
          support@Электронно торговая площадка.kz
          <br />
          +7 747 596 30 16
          <br />
          {t("privacy_page.city")}
        </Typography>

        <Button component='a' variant="contained" href="/page-signup" sx={{ textDecoration: "none" }}>
          {t("privacy_page.back_to_signup")}
        </Button>
      </Box>
    </Box>
  );
};

export default ContactCard;
